import React from 'react';
import { Hero } from './components/Hero';
import { Introduction } from './components/Introduction';
import { Categories } from './components/Categories';
import { Benefits } from './components/Benefits';
import { Quote } from './components/Quote';
import { CTA } from './components/CTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-cream font-sans text-gray-800" data-id="element-0">
      <Hero data-id="element-1" />
      <Introduction data-id="element-2" />
      <Categories data-id="element-3" />
      <Benefits data-id="element-4" />
      <Quote data-id="element-5" />
      <CTA data-id="element-6" />
      <Footer data-id="element-7" />
    </div>;
}